import * as React from 'react'
import { createComponent } from 'react-fela'
import PropTypes from 'prop-types'

import Icon from 'design-framework/common/ui/Icon'
import ArrowUp from 'design-framework/common/icons/arrow-up.svg'
import ArrowDown from 'design-framework/common/icons/arrow-down.svg'

// styles
import {
	__container,
	__headerContainer,
	__iconContainer,
	__toggle,
} from './__style'

const Container = createComponent(__container, 'div', ['onClick'])
const HeaderContainer = createComponent(__headerContainer, 'div')
const IconContainer = createComponent(__iconContainer, 'div')
const Toggle = createComponent(__toggle, 'div')

class Accordion extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isOpen: props.isOpen || false,
		}
	}

	onClick = e => {
		e.preventDefault()
		const { disableOnClick, onClick } = this.props

		const { isOpen } = this.state

		if (!disableOnClick) {
			this.setState(prevState => ({
				...prevState,
				isOpen: !prevState.isOpen,
			}))
		}

		// callback function providing isOpen value
		onClick({
			isOpen: !isOpen,
		})
	}

	renderHeader = alignment => {
		const { isOpen } = this.state

		const {
			renderCustomIcon,
			upArrowIcon,
			downArrowIcon,
			renderHeader,
			iconStyles,
		} = this.props

		if (alignment === 'LEFT') {
			return (
				<>
					<IconContainer style={{ marginLeft: '0px', ...iconStyles }}>
						{renderCustomIcon &&
							(isOpen ? upArrowIcon : downArrowIcon)}
						{!renderCustomIcon && (
							<Icon glyph={isOpen ? ArrowUp : ArrowDown} />
						)}
					</IconContainer>
					<HeaderContainer>{renderHeader}</HeaderContainer>
				</>
			)
		}

		return (
			<>
				<HeaderContainer>{renderHeader}</HeaderContainer>
				<IconContainer style={iconStyles}>
					{renderCustomIcon && (isOpen ? upArrowIcon : downArrowIcon)}
					{!renderCustomIcon && (
						<Icon glyph={isOpen ? ArrowUp : ArrowDown} />
					)}
				</IconContainer>
			</>
		)
	}

	render() {
		const { isOpen } = this.state
		const { renderDropDown, styles, alignment } = this.props

		return (
			<>
				<Container onClick={this.onClick} style={styles}>
					{this.renderHeader(alignment)}
				</Container>
				<Toggle isOpen={isOpen} style={styles}>
					<div>{renderDropDown}</div>
				</Toggle>
			</>
		)
	}
}

Accordion.defaultProps = {
	renderCustomIcon: false,
	disableOnClick: false,
	onClick: () => {},
}

Accordion.propTypes = {
	/** Header component */
	renderHeader: PropTypes.elementType,
	/** Drop down component */
	renderDropDown: PropTypes.elementType,
	/** Up arrow Icon */
	upArrowIcon: PropTypes.elementType,
	/** Down arrow Icon */
	downArrowIcon: PropTypes.elementType,
	/** Render custom icon or not default to false */
	renderCustomIcon: PropTypes.bool,
	/** Disable on click functionality defaults to false */
	disableOnClick: PropTypes.bool,
	/** On click callback */
	onClick: PropTypes.func,
	/** isOpen defaults to false. Determines the initial functionality of accordion. Only used in initializing */
	isOpen: PropTypes.bool,
	/** Custom styles applied to header and drop down container. Can be used to provide a background color etc */
	styles: PropTypes.object,
	/** Alignment of the icon. Determines the alignment of the icon  (RIGHT/LEFT) */
	alignment: PropTypes.string,
	/** icon styles used to style the icons. Use width for size of the icon */
	iconStyles: PropTypes.object,
}

export default Accordion
